import ajax from './ajax'

/**用户权限列表
 */
export function getUserMenu() {
  return ajax({
    url: '/vw-security-manage-boot/user/current/status',
    method: 'get',
    business: 'apply',
  })
}

/**
 * 获取密钥列表
 */
export function getSecret() {
  return ajax({
    url: '/vw-security-manage-boot/api/v1/keyName/list',
    method: 'get',
    business: 'apply',
  })
}



